// src/hooks/useDocumentTitle.ts
import { useEffect } from 'react';

/**
 * Custom hook to dynamically update the document title
 * @param title - The page title (e.g., "Dashboard", "Onboarding")
 * @param prefix - Optional prefix (defaults to "Cluva")
 */
export const useDocumentTitle = (title: string, prefix: string = "Cluva") => {
  useEffect(() => {
    const fullTitle = title ? `${prefix} | ${title}` : prefix;
    document.title = fullTitle;
    
    // Cleanup: Reset to default title when component unmounts
    return () => {
      document.title = prefix;
    };
  }, [title, prefix]);
};

export default useDocumentTitle;